<template>
  <section>
    <div class="level">
      <div class="level-left">
        <div class="image">
          <img id="hp-logo" src="/static/img/logo/HPB-logo-on-white.svg" srcset="" />
          <qrcode-vue :value="businessCopyUrl" :size="size" level="H"></qrcode-vue>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import QrcodeVue from 'qrcode.vue'
  export default {
    name: 'ReviewQRCodesWidget',
    data () {
         return {
            businessSlug: this.$route.params.slug,
            consumerFrontendUrl: process.env.HP_APP_URL,
            portalQRCodeInvite: process.env.PORTAL_QRCODE_INVITE,
            size: 200
          }
        },
    components: {
        QrcodeVue
    },
    computed: {
       businessCopyUrl () {
          return `${this.consumerFrontendUrl}/write-a-review/${this.businessSlug}?source=${this.portalQRCodeInvite}&r=true`
        }
      }
  }
</script>
<style scoped>
  .image {
    width: 215px;
    display: block;
    background-repeat: no-repeat;
    margin-right: auto;
    margin-left: auto;
  }
</style>



// WEBPACK FOOTER //
// src/widgets/ReviewQRCodesWidget.vue